import { graphql } from "../gql";

export const setUserMfaPreferenceMutationDoc = graphql(`
  mutation setUserMfaPreference($input: UserMfaPreferenceInput!) {
    setUserMfaPreference(input: $input) {
      message
      success
    }
  }
`);
